import AXIOS from '@/axios-instance';

export default {

  saveQuestion(uuid, elementId, text, assignee) {
    return AXIOS.post("/bpmn/"+ uuid + "/element/"+ elementId + "/question", {
      questionText: text,
      assignee: assignee
    });
  },
  retrieveQuestions(uuidModel, elementId) {
    return AXIOS.get("/bpmn/" + uuidModel + "/element/" + elementId);
  },
}